import { Box, TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import ControlledNumberField from '~components/Form/ControlledNumberField';
import { ParameterTransferExternal } from '~pages/SipConfiguration/domain';

import BaseNode from '../BaseNode';
import { ContactFlowNodeProps } from '..';

export default function TransferExternalNode(props: ContactFlowNodeProps) {
  const form = useForm<ParameterTransferExternal>({
    defaultValues: props.data.parameter.transferExternal,
  });

  return (
    <BaseNode
      {...props}
      title='Transfer External'
      parameterForm={form}
      renderParameterForm={(transferExternal) => (
        <>
          <Typography>Endpoint: {transferExternal?.endpoint || '--'}</Typography>
          <Typography>From Attribute: {transferExternal?.fromAttribute || '--'}</Typography>
          <Typography>Timeout (sec): {transferExternal?.timeoutSecond ?? '--'}</Typography>
          <Typography>Timeout Message Key: {transferExternal?.timeoutMessageKey || '--'}</Typography>
        </>
      )}
      transformParameter={(transferExternal) => ({ transferExternal })}
      renderEditParameter={({ control }) => (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}>
          <Controller
            control={control}
            name='endpoint'
            defaultValue=''
            render={({ field }) => <TextField {...field} fullWidth label='Endpoint' />}
          />
          <Controller
            control={control}
            name='fromAttribute'
            defaultValue=''
            render={({ field }) => <TextField {...field} fullWidth label='From Attribute' />}
          />
          <ControlledNumberField name='timeoutSecond' control={control} label='Timeout (sec)' defaultValue='' />
          <Controller
            control={control}
            name='timeoutMessageKey'
            defaultValue=''
            rules={{
              required: 'Timeout message key required.',
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label='Timeout Message Key'
                error={Boolean(error)}
                helperText={error?.message}
              />
            )}
          />
        </Box>
      )}
    />
  );
}
